// UI access check only. RPC/Edge Function authorization remains the security boundary.
export async function verifyMilliOwner(client, expectedUserId) {
  if (!expectedUserId) return false;
  // Validate with Auth; never authorize from cached session/user metadata.
  const { data: authData, error: authError } = await client.auth.getUser();
  if (authError) throw authError;
  if (authData?.user?.id !== expectedUserId) return false;

  const { data, error } = await client.rpc('_kc_is_owner');
  if (error) throw error;
  return data === true;
}
